import * as React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import emailjs from '@emailjs/browser';

emailjs.init('2OiPn6mpaF9jLe7Uh');
const rootElement = document.getElementById('root');
const root = createRoot(rootElement!);
root.render(<App />);
